import { createFileRoute } from '@tanstack/react-router'

import { LoginPage } from '../../components/pages/login/login-page.tsx'
import { recordLoginBounce } from '../../shared/routing/detect-login-redirect-loop.ts'

export const Route = createFileRoute('/login')({
  // Counted on arrival, so a route guard and a full page load from an API error count the same way.
  // A preload is speculative and is not an arrival.
  beforeLoad: ({ location, preload, search }) => {
    if (search.from_unauthorized_code && !preload) {
      recordLoginBounce(location.href)
    }
  },
  component: LoginPage,
})
